export class PageNotFoundError extends Error {
  constructor(message: string = 'Page not found') {
    super(message);
  }
}
